import useApi from "..";

const useMyGarageApi = () => {
    const { request } = useApi(); 
  
    const getVehicles = () => request('/mygarage/vehicles', 'GET', null);
    const getVehicleByRegNum = (regNum) => request(`/mygarage/vehicle/?vehicleRegistrationNumber=${regNum}`, 'GET', null);
    const deleteVehicle = (regNum) => request(`/mygarage/vehicle/delete?vehicleRegistrationNumber=${regNum}`, 'DELETE', null);
    const verifyVehicle = (payload) => request('/mygarage/vehicle/verify', 'POST', payload);
    const addVehicles = (payload) => request('/mygarage/vehicles/add', 'POST', payload);
    
    
    return { 
        getVehicles,
        getVehicleByRegNum,
        deleteVehicle,
        verifyVehicle,
        addVehicles
    };
};

export default useMyGarageApi;
